import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import UIButton from 'UIComponents/button/UIButton';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
export default function OnboardingTourShowMeHowText({
  className,
  stepId,
  tourData,
  tourId
}) {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const trackTourInteraction = useTourTrackingMethod('trackTourInteraction');
  const {
    i18nPrefix
  } = tourData;
  const stepIndex = tourData.steps.findIndex(step => step.id === stepId);
  const i18nStepIndex = stepIndex + 1;
  const {
    showMeHowModal: Modal,
    showMeHowClickHandler
  } = tourData.steps[stepIndex];

  if (!isValidI18nKey(`onboarding-tours-${i18nPrefix}.step${i18nStepIndex}.showMeHow_jsx`)) {
    return null;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link: props => /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
          onClick: event => {
            if (Modal) {
              setShouldShowModal(true);
            }

            if (typeof showMeHowClickHandler === 'function') {
              showMeHowClickHandler(event);
            }

            if (trackTourInteraction) {
              trackTourInteraction(tourId, stepId, 'click show me how link');
            }
          },
          use: "link"
        }))
      },
      message: `onboarding-tours-${i18nPrefix}.step${i18nStepIndex}.showMeHow_jsx`
    }), Modal && shouldShowModal && /*#__PURE__*/_jsx(Modal, {
      onClose: () => setShouldShowModal(false),
      trackTourInteraction: action => {
        if (trackTourInteraction) {
          trackTourInteraction(tourId, stepId, action);
        }
      }
    })]
  });
}